'use client';

import { HeadingText } from '@/components/atoms/HeadingText';
import { InputText } from '@/components/atoms/Inputs/InputText';
import { Select } from '@/components/atoms/Inputs/Select';
import { useFormContext } from '@/components/forms/FormContext';
import { PictureStepActions } from '@/app/replace/virtual/components/ReplaceVirtuallyForm/steps/PictureStep/state';
import { IconInfoBubble } from '@/components/icons';
import {
	ReplaceVirtuallyFormState,
	StepMap,
} from '@/app/replace/virtual/components/ReplaceVirtuallyForm/constants';
import { ReplaceVirtuallyFormActionMap } from '@/app/replace/virtual/components/ReplaceVirtuallyForm/reducer';
import { TextAlert } from '@/components/calculators/TextAlert';

export interface SystemModelNumberLocationSubStepProps {
	testId?: string;
}

const SystemModelNumberLocationSubStep = (
	props: SystemModelNumberLocationSubStepProps,
) => {
	const { testId = 'SystemModelNumberLocationSubStep' } = props;
	const { state, dispatch } = useFormContext<
		StepMap,
		ReplaceVirtuallyFormState,
		ReplaceVirtuallyFormActionMap
	>();

	function handleModelNumChange(event: React.ChangeEvent<HTMLInputElement>) {
		dispatch({
			type: PictureStepActions.UPDATE_MODEL_NUMBER,
			payload: event.target.value,
		});
	}

	function handleSystemLocationChange(
		event: React.ChangeEvent<HTMLSelectElement>,
	) {
		dispatch({
			type: PictureStepActions.UPDATE_SYSTEM_LOCATION,
			payload: event.target.value,
		});
	}

	return (
		<>
			<div data-testid={testId} className="hvac-container">
				<HeadingText
					tag="h2"
					balanced
					className="mx-auto mb-10 mt-4 max-w-5xl lg:mb-14 lg:mt-14"
				>
					Okay, provide the following information about your HVAC system
				</HeadingText>

				<div className="mx-auto mb-8 max-w-101 lg:mb-10">
					<InputText
						id="modelNumber"
						name="modelNumber"
						label="Outdoor unit model number"
						inputClassName="mb-2"
						value={state.modelNumber}
						onChange={handleModelNumChange}
					/>
					<p className="pl-1 text-xs text-slate-500">
						This is normally on the label on the back of the unit
					</p>

					<Select
						id="systemLocation"
						name="systemLocation"
						label="Furnace or air handler location"
						containerProps={{ className: 'mt-4' }}
						value={state.systemLocation}
						onChange={handleSystemLocationChange}
					>
						<option></option>
						<option value="Basement">Basement</option>
						<option value="Crawlspace">Crawlspace</option>
						<option value="Attic">Attic</option>
						<option value="Closet">Closet</option>
						<option value="Multiple Locations">Multiple Locations</option>
						<option value="Other">Other</option>
						<option value="Not Sure">Not Sure</option>
						<option value="I don't have one">I Don&apos;t Have One</option>
					</Select>
				</div>
				<TextAlert
					id="WhyAsking"
					renderIcon={IconInfoBubble}
					title="Why are we asking?"
					text="The model of your outdoor unit and heating source location tell us everything we need to know about your system."
				/>
			</div>
		</>
	);
};

export default SystemModelNumberLocationSubStep;
